import axiosInstance from "./axiosInstance";
import { API_ENDPOINTS } from "./endpoints";

export const deleteTeam = async (teamIds: String[]) => {
  try {
    const response = await axiosInstance.delete(`${API_ENDPOINTS.team}/delete`, { data: { teamIds } });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "팀 삭제 실패!");
  }
};

export const restoreTeam = async (teamIds: String[]) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.team}/restore`, { teamIds });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "팀 삭제 실패!");
  }
};

export const registerClass = async (name: String, url: String, type: String, teacherUserId: String) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.team}/create`, [{ name, url, type, teacherUserId }]);
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "팀 생성 실패!");
  }
};

export const deleteTeamUsers = async (teamIds: String[], userIds: String[]) => {
  try {
    const response = await axiosInstance.delete(`${API_ENDPOINTS.team}/remove/users`, { data: { teamIds, userIds } });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "팀에서 유저 삭제에 실패하셨습니다.")
    console.log(error, "팀에서 유저 삭제 실패!");
  }
};

export const addTeamUsers = async (teamIds: string[], userIds: string[]) => {
  try {
    const response = await axiosInstance.post(`${API_ENDPOINTS.team}/add/users`, { teamIds, userIds });
    return response.data;
  } catch (error: any) {
    // throw new Error(error.response?.data?.message || "채널 검색에 실패하셨습니다.")
    console.log(error, "팀에 유저 추가 실패!");
  }
};
